import { cn } from "@/lib/utils";

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  container?: boolean;
  alt?: boolean;
}

export function Section({
  as: Component = "section",
  className,
  container = true,
  alt = false,
  children,
  ...props
}: SectionProps) {
  return (
    <Component
      className={cn(
        "py-16 md:py-24",
        alt ? "bg-paleSky" : "bg-seaMist",
        className
      )}
      {...props}
    >
      {container ? (
        <div className="container-main">{children}</div>
      ) : (
        children
      )}
    </Component>
  );
}
